<!-- <mat-card-content> -->
<div class="container-fluid" *ngIf="!data.for">
	<div class="row mt-3">
		<div class="col-md-12">
			<div class="card-block shadow p-1">
				<div class="bg-white text-uppercase font-bold pl-2">
					<span *ngIf="paying"> PAYMENT DETAILS </span>
					<span *ngIf="warning">NOTICE </span>
				</div>
			</div>
		</div>
	</div>

	<div class="row mt-3" *ngIf="warning">
		<div class="col-12">
			To register for new course(s), you will need to pay for them.

			<div class="mt-2" align="right">
				<button class="btn mt-2 mb-3 initialism shadow-lg" [mat-dialog-close]="{pay: true}" mat-button
					mat-raised-button>Make Payment</button>
			</div>
		</div>
	</div>

	<div class="row" *ngIf="paying">
		<div class="col-12 pt-2">
			You are about to make payment and register for the following courses: <br><br>
			<div *ngFor="let course of payment.courses" style="text-transform: uppercase" [title]="course.f_desc">
				<mat-checkbox [checked]="true" disabled>{{course.title}} - {{course.s_desc}}
					[{{course.unit}}]</mat-checkbox>
			</div>

			<hr>
			<div>
				<strong>{{payment.amount + payment.charges | currency:'NGN':'symbol-narrow'}}</strong><br>
				<span style="color: grey">
					Amount: {{payment.amount | currency:'NGN':'symbol-narrow'}} |
					Transaction Charge: {{payment.charges | currency:'NGN':'symbol-narrow'}}
				</span>

				<!-- <div align="center" class="mt-2">
              <button class="btn mt-2  initialism shadow text-dark" [mat-dialog-close]="{proceed: true}" mat-button mat-raised-button>Proceed</button>
            </div> -->
				<div align="right" class="mt-2">
					<button class="btn float-right w-25 mt-2 mb-3 initialism shadow-lg"
						[mat-dialog-close]="{proceed: true}" mat-button mat-raised-button>Proceed</button>
				</div>

			</div>
		</div>


	</div>
</div>
<div class="container-fluid p-3" *ngIf="data.for == 'wallet'">
	<div class="row" *ngIf="display == 0">
		<div class="col-12">
			<h5>Make payment by reference</h5>
			<div>Transfer to the school account and enter payment reference below: <br> <br>
				<ul>
					<li *ngFor="let account of data.pay.accounts">{{account.account_number}} {{account.account_name}}
						{{account.bank_name}}</li>
				</ul>
			</div>
		</div>
	</div>
	<div class="row" *ngIf="display == 0">
		<mat-form-field class="col-12" appearance="outline">
			<mat-label>Transaction Reference</mat-label>
			<input type="text" matInput [(ngModel)]="reference" />
			<mat-hint class="text-danger">{{message}}</mat-hint>
		</mat-form-field>

		<div class="col-12" align="right">
			<button mat-button mat-raised-button color="primary" (click)="verifyPayment()">Verify Payment</button>
		</div>
	</div>

	<div class="row" *ngIf="display == 1">
		<div class="col-12">
			<p><strong>Payment Verified!</strong></p>
			<p>
				<small>Amount to be Paid: <b>{{data.pay.amount}}</b></small> <br>
				<small>Amount Paid: <b>{{payData.amount / 100}}</b></small>
			</p>
		</div>
		<div class="col-12" align="right">
			<button mat-button mat-raised-button class="primary-color" style="color: white" (click)="makePayment()">Make
				Payment</button>
		</div>
	</div>
</div>

<div class="container-fluid overflow-hidden" *ngIf="data.for == 'view_image'">
	<div class="row" class="overflow-hidden">
		<div class="col-md-12">
			<img [src]="data.image" class="img-fluid overflow-hidden" onerror="this.src='assets/images/notFound.png'" />
		</div>
	</div>
</div>

<div class="container-fluid p-3" *ngIf="data.for == 'pay_upload'">
	<div class="row">
		<div class="col-12">
			<h6>Upload proof of payment</h6>
			<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
			<br>
			<div class="row">
				<div class="col-12" *ngIf="!foundPaymentUpload">
					<hr>
					<small><b>No Payment Slip uploaded yet</b></small>
				</div>
				<div class="col-12">
					<mat-form-field class="w-100" appearance="outline">
						<mat-label>Amount</mat-label>
						<input type="number" matInput required [(ngModel)]="slipAmount" />
					</mat-form-field>
					<mat-form-field class="w-100" appearance="outline">
						<mat-label>Payment date</mat-label>
						<input type="date" placeholder="When did you make this payment?" matInput required
							[(ngModel)]="slipDate" />
					</mat-form-field>
					<div class="custom-file mb-3">
						<input type="file" (change)="onFileSelected($event)" class="custom-file-input"
							id="validatedCustomFile" required>
						<label class="custom-file-label"
							for="validatedCustomFile">{{selectedFile ? selectedFile.name : 'Choose file'}}</label>
					</div>
					<!-- <input #fileInput class="form-control " type="file"  required  /> -->
					<button mat-raised-button class="btn-sm btn-primary" (click)="uploadSlip()">Upload Slip</button>
					<mat-checkbox class="float-right mt-2" [(ngModel)]="showUploaded"><small>Show Uploaded
							Slips</small></mat-checkbox>
				</div>

			</div>

			<div *ngIf="showUploaded">
				<small *ngIf="!foundPaymentUpload">No Payment Slip Found</small>
				<div class="row mb-2 mt-2" *ngIf="foundPaymentUpload" style="height: 40vh; overflow: auto">
					<div class="col-6 col-md-4 p-2 mb-2" *ngFor="let pay of foundPaymentUpload">
						<div class="card p-0 shadow">
							<img src="{{pay.slip}}" alt="Payment slip" class="" height="150"
								(click)="viewImage(pay.slip)">
							<div class="card-body p-3">
								<p style="font-size: 10pt">
									<b
										[class]="pay.status == 'approved' ? 'badge badge-success' : pay.status == 'pending' ? 'badge badge-warning' : 'badge badge-danger'">{{pay.status}}</b>
									<br>

									<b class="text-danger"
										*ngIf="pay.status == 'rejected' && pay.rejection_reason">Reason:
										{{pay.rejection_reason}}</b> <br>

									<b>{{pay.amount/100 | currency:'NGN':'symbol-narrow'}}</b>
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="container-fluid p-3" *ngIf="data.for == 'hostel'">
	<div class="row">
		<div class="col-12">
			<h6>Hostel and Accomodaton</h6>
			<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
			<br>
			<div class="row">
				<div class="col-12" *ngIf="editing">
					<hr>
					<small><b>Current Hostel: {{data.hostel_name}} -
							{{data.total_amount | currency:'NGN':'symbol-narrow'}}</b></small>
				</div>
				<div class="col-12">
					<mat-form-field class="col-md-12">
						<mat-select matInput placeholder="Hostel" disableOptionCentering panelClass="panelClass"
							class="initialism" [(ngModel)]="selectedHostel" required>
							<mat-option *ngFor="let hostel of hostelArr" [value]="hostel"
								class="initialism text-uppercase">
								{{ hostel.hostel_name }}
							</mat-option>
						</mat-select>
					</mat-form-field>

					<div *ngIf="selectedHostel">
						<small><strong>Hostel Details</strong></small> <br>
						<small>Address: {{selectedHostel.hostel_address}}</small>
						<div class="row">
							<div class="col-10"><b>Fee</b></div>
							<div class="col-2"><b>Amount</b></div>
						</div>
						<div class="row" *ngFor="let fee of selectedHostel.fees">
							<div class="col-10"><small>{{fee.title}}</small></div>
							<div class="col-2"><small>{{fee.amount}}</small></div>
						</div>
						<div class="row">
							<div class="col-10"><strong><small>Total:</small></strong></div>
							<div class="col-2"><strong><small>{{selectedHostel.total_amount}}</small></strong></div>
						</div>


						<button mat-raised-button color="primary" (click)="submitHostel()">Submit</button>
					</div>
				</div>

			</div>
		</div>
	</div>
</div>
<!-- </mat-card-content> -->